// Guide/GuidePage.tsx

import React, {useEffect, useState} from 'react';
import {CircularProgress, Typography} from '@mui/material';
import {useNavigate, useParams} from 'react-router-dom';
import {axios, DOMAIN_URL} from 'Auth/axiosConfig';
import pprint from '../../Utils/pprint';
import {FC, FCCC} from 'WideLayout/Layouts';
import {useTheme} from 'Theme/ThemeContext';
import GuideDetail from "Guide/GuideDetail";
import Head from "Core/components/Head";
import {IGuide} from "Types/psychology/guide";

interface GuidePageProps {
    guide?: IGuide;
    cls?: string;
}

const GuidePage: React.FC<GuidePageProps> = ({guide: propGuide, cls}) => {
    const {productId} = useParams<{ productId: string }>();
    const [guide, setGuide] = useState<IGuide | null>(propGuide || null);
    const [loading, setLoading] = useState<boolean>(!propGuide);
    const [error, setError] = useState<string | null>(null);
    const {plt} = useTheme();
    const navigate = useNavigate();

    useEffect(() => {
        if (!propGuide && productId) {
            const fetchGuide = async () => {
                try {
                    const response = await axios.get(`/api/v1/guides/${productId}/`);
                    pprint('Guide fetched:', response.data);
                    setGuide(response.data);
                } catch (err: any) {
                    console.error('Error fetching guide:', err);
                    setError('Ошибка при загрузке гайда.');
                } finally {
                    setLoading(false);
                }
            };
            fetchGuide();
        }
    }, [productId, propGuide]);

    if (loading)
        return (
            <FCCC h={'100%'}>
                <CircularProgress size={'150px'}/>
            </FCCC>
        );
    if (error)
        return (
            <Typography color="error" align="center" mt={4}>
                {error}
            </Typography>
        );
    if (!guide)
        return (
            <Typography align="center" mt={4}>
                Гайд не найден
            </Typography>
        );

    return (
        <><Head
            title={`Курс ${guide.name} | Лайф Хелп`}
            description={'Помощь квалифицированных психологов от сервиса Лайф Хелп'}
            robots={'noindex, nofollow'}
            canonicalUrl={`${DOMAIN_URL}/guide/${guide.id}`}/><FC cls={cls} p={2} g={1} h={'100%'} scroll={'y-auto'}>
            <GuideDetail guide={guide}/>
        </FC></>
    );
};

export default GuidePage;
